import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export const FounderPromise = () => (
  <section className="relative bg-[#FFFFFF] py-28 md:py-36" data-testid="founder-promise">
    <div className="max-w-[1440px] mx-auto px-6 md:px-10">
      <motion.div
        initial={{ opacity: 0, y: 32 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: [0.65, 0, 0.35, 1] }}
        className="tacc-card border-[#F59E0B]/30 p-10 md:p-16 max-w-4xl mx-auto"
      >
        <div className="section-tag mb-6">§ The Founder&apos;s Promise</div>
        <h2 className="font-display text-4xl md:text-5xl leading-[0.98] tracking-tight mb-8">
          Why I built <span className="italic text-[#B45309]">this</span>.
        </h2>
        <div className="space-y-5 text-[#44403C] text-lg leading-relaxed font-display italic">
          <p>
            I built T.A.C.C. because I needed it and it didn&apos;t exist. I know what it is to clock in
            carrying things no schedule accounts for — and to be told to leave it at the door,
            as if a door could hold it.
          </p>
          <p>
            So here is my promise. Nothing on this platform is borrowed, invented, or dressed up.
            The modules are the exact protocols I built and refined for ten years. The voice in the
            audio is mine. When you see a story here, it will be from a real person who walked through.
          </p>
          <p>
            You don&apos;t go around it. You go through it. And you won&apos;t go through it alone.
          </p>
        </div>
        <div className="mt-10 flex flex-wrap items-center justify-between gap-6">
          <div>
            <div className="font-display text-2xl text-[#B45309]">— Rich Culmer</div>
            <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-[#78716C] mt-1">Founder · T.A.C.C.</div>
          </div>
          <div className="text-right">
            <Link to="/register" data-testid="founders-circle-cta" className="btn-ember text-sm">
              Join the Founder&apos;s Circle <ArrowUpRight size={16} />
            </Link>
            <p className="font-mono text-[9px] tracking-[0.2em] uppercase text-[#78716C] mt-3 max-w-[260px]">
              The first ten members. Their stories become this page.
            </p>
          </div>
        </div>
      </motion.div>
    </div>
  </section>
);
